import { areBufferedChildrenFiltersOnSelector, useFiltersV2Store } from "PFApp/components/filters_v2";
import { Accordion } from "PFComponents/accordion";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { FiltersV2 } from "PFTypes/filters_v2";
import { useTranslation } from "react-i18next";

import { FiltersV2List } from "../../filters_v2_list";
import css from "../filters_v2_panel.module.scss";
import { FiltersV2ChildrenToggle } from "./filters_v2_children_toggle";

type FiltersV2ChildrenAccordionProps = {
  filters: FiltersV2;
  lastFocusedFilterNameRef: React.MutableRefObject<string | null>;
  label?: string;
  childrenToggleInfo?: string;
};

export const FiltersV2ChildrenAccordion = ({
  filters,
  label,
  childrenToggleInfo,
  lastFocusedFilterNameRef
}: FiltersV2ChildrenAccordionProps) => {
  const { t } = useTranslation("filters");
  const areChildrenOn = useFiltersV2Store(areBufferedChildrenFiltersOnSelector);

  const toggle = (
    <FiltersV2ChildrenToggle
      title={label || t("children.title")}
      info={childrenToggleInfo || t("children.info")}
    />
  );

  if (!areChildrenOn) {
    return (
      <Inline alignItems="center" className={css.childrenFiltersToggleWrapper}>
        <Typography variant={"h4"}>{label || t("panel.title")}</Typography>
        {toggle}
      </Inline>
    );
  }

  return (
    <Accordion
      header={label || t("panel.title")}
      actions={toggle}
      state={areChildrenOn ? "open" : "closed"}
      animated={false}
    >
      <FiltersV2List lastFocusedFilterNameRef={lastFocusedFilterNameRef} filters={filters} />
    </Accordion>
  );
};
